<template>
    <section id="datasiswa">
        <!-- <div class="rows"> -->
            <!-- <div class="row">
                <b-button  class="button is-primary" 
                tag="router-link"
                to="/biro/berandasiswa"
                icon-left="arrow-left-bold">Kembali</b-button>
            </div> -->
        <div class="row">
            <div class="box mw-980">
                <h4 class="title is-5 has-text-centered">{{ actionTitle }} Data Siswa</h4>
                <section>
                    <b-field horizontal label="Nama Siswa"
                    :type="form.nama_siswa.type"
                    :message ="form.nama_siswa.message">
                            <b-input name="nama_siswa"  @input="clearError(form.nama_siswa)" v-model="form.nama_siswa.value"
                            placeholder="Nama Siswa" expanded></b-input>
                    </b-field>
                    <b-field horizontal label="Email"
                        :type="form.email.type"
                        :message ="form.email.message">
                            <b-input name="email" placeholder="Email"
                            @input="clearError(form.email)" v-model="form.email.value" expanded></b-input>
                        </b-field>
                        <b-field horizontal label="Jenis Kelamin"
                        :type="form.jenis_kelamin.type"
                        :message ="form.jenis_kelamin.message">
                        <b-select @input="clearError(form.jenis_kelamin)" 
                        v-model="form.jenis_kelamin.value" placeholder="Select one" expanded>
                            <option value="Laki-Laki">Laki-Laki</option>
                            <option value="Perempuan">Perempuan</option>
                        </b-select>
                    </b-field>
                    <b-field horizontal label="Tanggal Lahir"
                    :type="form.tgl_lahir.type"
                    :message ="form.tgl_lahir.message">
                            <b-datepicker
                            ref="datepicker"
                            v-model="form.tgl_lahir.value"
                            :max-date="new Date()"
                            @input="clearError(form.tgl_lahir)"
                            placeholder="Select a date">
                                
                        </b-datepicker>
                        <b-button
                            @click="$refs.datepicker.toggle()"
                            icon-left="calendar-today"
                            type="is-primary">
                        </b-button>
                    </b-field>
                    <b-field horizontal label="No Handphone/WA"
                    :type="form.no_handphone.type"
                    :message ="form.no_handphone.message">

                    <div class="columns">
                        <div class="column is-1">
                            <b-button label="+62" 
                                type="is-light"
                                disabled>
                            </b-button>
                        </div>
                        <div class="column">
                            <b-input name="no_handphone" placeholder="No Handphone/WA" 
                                @input="clearError(form.no_handphone)" v-model="form.no_handphone.value" expanded>
                            </b-input>
                        </div>
                    </div>
                    
                    
                    <!-- <b-button label="+62" 
                            type="is-light">
                    </b-button>
                        <b-input name="no_handphone" placeholder="No Handphone/WA" style="padding-right:600px"
                        @input="clearError(form.no_handphone)" v-model="form.no_handphone.value" expanded></b-input> -->
                    </b-field>

                <b-field horizontal label="Kelas"
                :type="form.kelas.type"
                :message ="form.kelas.message">
                <b-select @input="clearError(form.kelas)" 
                v-model="form.kelas.value" placeholder="Select one" expanded>
                    <option value="Kelas 1">Kelas 1</option>
                    <option value="Kelas 2">Kelas 2</option>
                    <option value="Kelas 3">Kelas 3</option>
                    <option value="Kelas 4">Kelas 4</option>
                    <option value="Kelas 5">Kelas 5</option>
                    <option value="Kelas 6">Kelas 6</option>
                    <option value="Kelas 7">Kelas 7</option>
                    <option value="Kelas 8">Kelas 8</option>
                    <option value="Kelas 9">Kelas 9</option>
                    <option value="Kelas 10">Kelas 10</option>
                    <option value="Kelas 11">Kelas 11</option>
                    <option value="Kelas 12">Kelas 12</option>
                </b-select>
                </b-field>
                <b-field horizontal label="Asal Sekolah"
                :type="form.nama_sekolah.type"
                :message="form.nama_sekolah.message">
                    <b-select v-model="form.nama_sekolah.value" @input="clearError(form.nama_sekolah)"  
                    placeholder="Select one" expanded>
                        <option v-for="(item) in sekolahs "
                        :key="item.id_sekolah"
                        :value="item.id_sekolah">
                        {{ item.nama_sekolah}}
                        </option>>
                    </b-select>
                </b-field>
                
    
                <!-- <b-field horizontal>
                    <p class="control">
                        <button class="button is-primary"
                        @click="confirm()">
                        Simpan
                        
                        </button>
                    </p>
                </b-field> -->
            </section>
            <div class="rows" style="margin-top: 24px">
                <div class="row">
                    <div class="columns">
                        <div class="column">
                            <b-button type="is-danger" 
                            class="mw-420" 
                            tag="router-link"
                            to="/biro/berandasiswa">Batal</b-button>
                        </div>
                        <div class="column">
                            <b-button type="is-info" class="mw-420" @click="confirm()">Simpan</b-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
        <!-- </div> -->
    <b-loading 
        :is-full-page="true" 
        :active.sync="isLoading" 
        :can-cancel="false">
    </b-loading>
    </section>
</template>

<script>
    export default {
        data() {
            return {
                detailId: 0,
                isLoading:false,
                actionTitle:'',
                editID:0,
                sekolahs:[],
                dataSiswa: new FormData(),
                editDataSiswa:{},
                form:
                {
                    nama_siswa:{value:'', type:'', message:''},
                    email:{value:'',type:'',message:''},
                    jenis_kelamin:{value:'',type:'',message:''},
                    tgl_lahir:{value:'',type:'',message:''},
                    no_handphone:{value:'',type:'',message:''},
                    kelas:{value:'',type:'',message:''},
                    nama_sekolah:{value:'',type:'',message:''},
                    id_regu:{value:'',type:'',message:''}

                },
                snackbarMesssage:'',
                config: {}
            }
        },
        methods:{
            getSekolah()
            {
                var uri = this.$apiUrl + 'sekolah/biro/' + this.detailId
                this.$http.get(uri, this.config).then(response=>
                {
                    this.sekolahs = response.data.value
                })
            },
            getData(editID)
            {
                var uri = this.$apiUrl + 'siswa/' + editID

                this.$http.get(uri, this.config).then(response=>{
                    this.editDataSiswa = response.data.value
                    this.formEdit(this.editDataSiswa)
                })
            },
            formEdit(dataSiswa)
            {
                this.form.nama_siswa.value = dataSiswa.nama_siswa;
                this.form.email.value = dataSiswa.email;
                this.form.jenis_kelamin.value = dataSiswa.jenis_kelamin;
                this.form.tgl_lahir.value = new Date(dataSiswa.tgl_lahir);
                this.form.no_handphone.value = dataSiswa.no_handphone;
                this.form.kelas.value = dataSiswa.kelas;
                this.form.nama_sekolah.value = dataSiswa.id_sekolah;
                this.form.id_regu.value = dataSiswa.id_regu;
            },
            convertTgl(tglLahir) {
                var formDate = tglLahir 
                var year = formDate.getFullYear()       
                var month = formDate.getMonth() + 1      
                var date = formDate.getDate()            

                month = (month < 10) ? '0' + month : month
                date = (date < 10) ? '0' + date : date

                var fixedDate = year + '-' + month + '-' + date

                return fixedDate
            },
             clearError(form)
            {
                console.log(form)
                form.type = ''
                form.message = ''
            },
             checkData()
            {
                let count = 0
                let regexHP = new RegExp(/^\d+$/)
                let regexNama =  new RegExp(/^[a-zA-Z\s]+$/)
                // let regexEmail = new RegExp(/^([a-z0-9_\.-]+)@([\da-z\.-]+)\.([a-z\.]{2,6})$/)
                let regexEmail = new RegExp(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/);
                // let regexEmail = new RegExp(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)

                if(this.form.nama_siswa.value === "")
                {
                    this.form.nama_siswa.type = 'is-danger'
                    this.form.nama_siswa.message = "Nama Siswa harus harus di isi"
                    count ++
                }else if(!regexNama.test(this.form.nama_siswa.value))
                {
                    this.form.nama_siswa.type = 'is-danger'
                    this.form.nama_siswa.message ="Nama Siswa tidak boleh angka dan karakter khusus"
                    count ++
                }
                if(this.form.email.value === "")
                {
                    this.form.email.type = 'is-danger'
                    this.form.email.message ="Email harus diisi"
                    count ++
                }else if(!regexEmail.test(this.form.email.value))
                {
                    this.form.email.type = 'is-danger'
                    this.form.email.message ="Email harus valid"
                    count ++
                }
                if(this.form.jenis_kelamin.value ==="")
                {
                    this.form.jenis_kelamin.type ='is-danger'
                    this.form.jenis_kelamin.message ="Jenis Kelamin harus diisi"
                    count ++
                }
                if(this.form.tgl_lahir.value ==="")
                {
                    this.form.tgl_lahir.type = 'is-danger'
                    this.form.tgl_lahir.message ="Tanggal harus diisi "
                    count ++
                }
                if(this.form.no_handphone.value =="")
                {
                    this.form.no_handphone.type ='is-danger'
                    this.form.no_handphone.message ="No Handphone harus diisi "
                    count ++
                }else if(!regexHP.test(this.form.no_handphone.value))
                {
                    this.form.no_handphone.type ='is-danger'
                    this.form.no_handphone.message ="No handphone diisi tanpa spasi dan karakter"
                    count ++
                }else if(this.form.no_handphone.value.length < 9 || this.form.no_handphone.value.length > 13)
                {
                    this.form.no_handphone.type ='is-danger'
                    this.form.no_handphone.message ="Panjang No Handphone 9 - 13 digit"
                    count ++

                }
                if(this.form.kelas.value ==="")
                {
                    this.form.kelas.type ='is-danger'
                    this.form.kelas.message ="Kelas Harus diisi"
                    count ++
                }
                if(this.form.nama_sekolah.value ==="")
                {
                    this.form.nama_sekolah.type ='is-danger'
                    this.form.nama_sekolah.message ="Asal Sekolah Harus diisi"
                    count ++
                }
               
                if(count >0)
                return false
            },
             tambahData()
            {
                 this.isLoading = true
                // console.log(this.form.tgl_lahir.value)
                //  console.log(this.convertTgl(this.form.tgl_lahir.value))
                if(this.checkData()== false)
                {
                    this.snackbar("Gagal...Silahkan input lagi", 'is-danger')
                    this.isLoading = false
                }else{
                    this.dataSiswa.append("nama_siswa",this.form.nama_siswa.value)
                    this.dataSiswa.append("email",this.form.email.value)
                    this.dataSiswa.append("jenis_kelamin",this.form.jenis_kelamin.value)
                     if(this.form.tgl_lahir.value !== ""){
                        this.dataSiswa.append("tgl_lahir",this.convertTgl(this.form.tgl_lahir.value))
                    } 
                    this.dataSiswa.append("no_handphone",this.form.no_handphone.value)
                    this.dataSiswa.append("kelas",this.form.kelas.value)
                    this.dataSiswa.append("id_sekolah",this.form.nama_sekolah.value)
                    var uri =this.$apiUrl + 'siswa';
                    this.$http.post(uri,this.dataSiswa, this.config).then(response=>{
                        this.isLoading = false
                        this.$router.push({ name :"BerandaSiswa"})
                        console.log(response.data.value)
                        this.snackbarMessage = response.data.message
                        this.snackbar("Data Berhasil Ditambah...",'is-success')
                    })
                    .catch(error=>{
                        this.errors = error;
                        this.isLoading = false
                        console.log(this.errors)
                        if(this.errors.message == "Request failed status code 400")
                        {
                            this.snackbar("Gagal Ditambahkan",'is-danger')
                        }else{
                            this.snackbar("Ada Inputan Salah.Silahkan coba lagi",'is-danger')
                        }
                    });
                }
                // this.isLoading = false
                //console.log(this.form.tgl_lahir.value)
            },
            editData(editID)
            {
                this.isLoading = true
                if(this.checkData()== false)
                {
                    this.snackbar("Gagal Diedit",'is-danger')
                    this.isLoading = false
                }else{
                    this.editDataSiswa.nama_siswa = this.form.nama_siswa.value
                    this.editDataSiswa.email =this.form.email.value
                    this.editDataSiswa.jenis_kelamin = this.form.jenis_kelamin.value
                     if(this.form.tgl_lahir.value !== ""){
                        this.editDataSiswa.tgl_lahir = this.convertTgl(this.form.tgl_lahir.value)
                    }
                   
                    this.editDataSiswa.no_handphone = this.form.no_handphone.value
                    this.editDataSiswa.kelas = this.form.kelas.value
                    this.editDataSiswa.id_sekolah = this.form.nama_sekolah.value
                    this.editDataSiswa.id_regu = this.form.id_regu.value

                    console.log(editID)
                    console.log(this.editDataSiswa)

                    var uri = this.$apiUrl + 'siswa/' +editID;
                    this.$http.post(uri,this.editDataSiswa, this.config).then(response=>{
                        this.isLoading = false
                        this.$router.push({name: "BerandaSiswa"})
                        this.snackbarMessage = response.data.message
                        this.snackbar("Data Berhasil Diedit",'is-success')
                    })
                    .catch(error=>{
                        this.errors = error;
                        this.isLoading = false
                        console.log(this.errors)
                        if(this.errors.message == "Request failed status code 400")
                        {
                            this.snackbar("Gagal Diedit",'is-danger')
                        }else{
                            this.snackbar("Silahkan coba lagi",'is-danger')
                        }
                    });
                }
                // this.isLoading = false
            },
            confirm()
            {
                this.editID == 0? this.tambahData() : this.editData(this.editID)
                 console.log(this.form.no_handphone.value.length)
            },
             snackbar(snackbarMessage,type)//utk edit
            {
                this.$buefy.toast.open({
                    duration : 5000, //3 detik
                    message: snackbarMessage,
                    type: type,
                    position: 'is-top',
                    actionText :'OK',
                    queue: false,
                    //type: 'is-success'
                })
            }, 

        },
         mounted()
        {
            if(this.$session.exists()){
                this.config = {
                    headers: {
                       'Authorization': 'Bearer ' + this.$session.get('token')
                    }
                }
            }
            this.detailId = this.$session.get('biro').id_biro
            this.getSekolah()
             if(this.$route.params.id)
            {
                this.editID = this.$route.params.id
                this.actionTitle = 'Ubah'
                // console.log(this.editID)
                this.getData(this.editID)
            }else{
                this.actionTitle = 'Tambah'
            }
            // this.isLoading=false

        }
    }
</script>

<style scoped>
  /* img.preview {
    width: 200px;
    background-color: white;
    border: 1px solid #DDD;
    padding: 5px;
  } */
  .mw-980 {
    max-width: 980px;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
  }
  .mw-420 {
    max-width: 420px;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
  }
</style>